import React, {Component} from 'react';
import Helmet from 'react-helmet';

const initialState = {
}

class DenyError extends Component {
  state = initialState;

  // 初期処理
  componentDidMount() {

    // 「GA計測用データレイヤースクリプト追加処理」を呼出す
    window.addDataLayerScript('jmbauth_smsotp_operation_refusal_error');
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    return (
      <section className="content">

        <Helmet
          title={messageList.denyError.M001_browserTitle} >
        </Helmet>

        {/* 画面タイトル表示部 */}
        <div className="ds-heading ds-heading--lg">
          <h1 className="ds-heading__title">{messageList.denyError.M002_pageTitle}</h1>
        </div>

        <div className="contentInner">
          {/* 操作ボタン表示部 */}
          <div className="buttonLayout">
            <div className="buttonWrap buttonWrap--center">
              <div className="ds-button ds-button--tertiary ds-button--large">
                <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                  <span className="ds-button__label">{messageList.denyError.M003_home}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default DenyError
